export type StatusType = "1" | "2" | "3";

export const StatusTextEnum = {
  "1": "Running",
  "2": "Stopped",
  "3": "error",
};

export const StatusColorEnum = {
  "1": "green",
  "2": "red",
  "3": "grey",
};

export enum LicenseTypes {
  "One time buy" = 1,
  "Subscription" = 2
}

export enum LicenseStatus {
  "Active" = 1,

  "Pending change" = 2,

  "Expiring" = 3,

  "Expired" = 4
}

// Status mapping: number => color and label
export const StatusColorMap: Record<number, 'success' | 'warning' | 'danger'> = {
  1: 'success',      // Active
  2: 'success',      // Pending change
  3: 'warning',      // Expiring
  4: 'danger',       // Expired
};
